<template>
  <b-modal :id="modalId" title="Edit Contact" hide-footer>
    <loading-screen :is-loading="isSaving"></loading-screen>
    <errors :error-list="serverErrors"></errors>

    <form @submit.prevent="updateContact">

      <div class="row">
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="firstNameInput">First Name</label>
            <input type="text" v-model="updatedContact.first_name" id="firstNameInput" class="form-control">
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="lastNameInput">Last Name</label>
            <input type="text" v-model="updatedContact.last_name" id="lastNameInput" class="form-control">
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="emailInput">Email</label>
            <input type="email" v-model="updatedContact.email" id="emailInput" class="form-control">
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="phoneInput">Phone</label>
            <input type="tel" v-model="updatedContact.phone_number" id="phoneInput" class="form-control">
          </div>
        </div>
      </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group mb-3">
          <label for="faxInput">Fax</label>
          <input type="tel" v-model="updatedContact.fax" id="faxPhoneInput" class="form-control">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group mb-3">
          <label for="phoneInput">Emergency Phone</label>
          <input type="tel" v-model="updatedContact.emergency_phone_number" id="emergencyPhoneInput" class="form-control">
        </div>
      </div>
    </div>

      <div class="row">
        <div class="col-md-12">
          <div class="form-group mb-3">
            <label for="notesInput">Notes</label>
            <textarea v-model="updatedContact.notes" id="notesInput" class="form-control"></textarea>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="form-group mb-4">
            <div class="form-check">
              <input type="checkbox" v-model="updatedContact.communicates_via_whatsapp" id="whatsappInput" class="form-check-input">
              <label class="form-check-label" for="whatsappInput">Communicates via WhatsApp</label>
            </div>
          </div>
        </div>
      </div>

      <button type="submit" class="btn btn-itg-dark" :disabled="isSaving"
              @click.prevent="updateContact">
        Update Contact
      </button>

    </form>
  </b-modal>
</template>

<script>
import axios from "axios";
import Forms from "../../../../../../mixins/Forms";

export default {
  name: "EditContactModal",
  props: ['contact'],
  data() {
    return {
      isSaving: false,
      serverErrors: [],
      updatedContact: {
        first_name: this.contact.first_name,
        last_name: this.contact.last_name,
        email: this.contact.email,
        phone_number: this.contact.phone_number,
        emergency_phone_number: this.contact.emergency_phone_number,
        notes: this.contact.notes,
        communicates_via_whatsapp: this.contact.communicates_via_whatsapp || false
      }
    }
  },
  mixins: [Forms],
  computed: {
    modalId() {
      return 'edit-contact-' + this.contact.id + '-modal';
    }
  },
  methods: {
    updateContact() {
      let vm = this;
      vm.serverErrors = [];
      vm.isSaving = true;

      axios.put(API_BASE + '/contacts/' + this.contact.id, vm.updatedContact).then(r => {
        vm.isSaving = false;
        vm.$emit('contact-updated');
        vm.$bvModal.hide(vm.modalId);
      }).catch(e => {
        console.log(e);
        vm.isSaving = false;
        vm.setErrors(e);
      });
    }
  }
}
</script>

<style scoped>

</style>
